import {
  GetEvaluationExamplesResponse,
  SyntheticTestResult,
} from "@financial-advisory/data-access/api-types";
import { createSlice } from "@reduxjs/toolkit";
import type { RootState } from "../store";
import { ProcessedClauseApi } from "./decisionProcesses";

interface EvaluationExamplesState {
  examplesByPaneId: Record<string, SyntheticTestResult[]>;
}

const initialState: EvaluationExamplesState = {
  examplesByPaneId: {},
};

export const evaluationExamplesSlice = createSlice({
  name: "evaluationExamples",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      ProcessedClauseApi.endpoints.getEvaluationExamples.matchFulfilled,
      (state, action) => {
        const paneId = action.meta.arg.originalArgs.pane_id;
        const response: GetEvaluationExamplesResponse = action.payload;
        state.examplesByPaneId[paneId] = response.examples;
      }
    );
  },
});

export const selectEvaluationExamplesByPaneId =
  (paneId: string | null) => (state: RootState) => {
    if (!paneId) return [];
    return state.evaluationExamples.examplesByPaneId[paneId] || [];
  };

export default evaluationExamplesSlice.reducer;
